/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Region } from './Region';
import {
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
} from './Region';

/**
 * Structure to create an anonymous person
 * @export
 * @interface AnonymousPersonCreateReq
 */
export interface AnonymousPersonCreateReq {
    /**
     * 
     * @type {Region}
     * @memberof AnonymousPersonCreateReq
     */
    region?: Region;
}

/**
 * Check if a given object implements the AnonymousPersonCreateReq interface.
 */
export function instanceOfAnonymousPersonCreateReq(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AnonymousPersonCreateReqFromJSON(json: any): AnonymousPersonCreateReq {
    return AnonymousPersonCreateReqFromJSONTyped(json, false);
}

export function AnonymousPersonCreateReqFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnonymousPersonCreateReq {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'region': !exists(json, 'region') ? undefined : RegionFromJSON(json['region']),
    };
}

export function AnonymousPersonCreateReqToJSON(value?: AnonymousPersonCreateReq | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'region': RegionToJSON(value.region),
    };
}

